import { dateLib } from "@agentcall/core/lib"
import { ArrowRight, MessageCircle } from "react-feather"
import { Link } from "react-router-dom"
import { type TicketList200TicketsItem, ticketApi } from "@/api/client/ticket"
import { Button } from "@/components/ui/button/button"
import { DefaultCard } from "@/components/ui/card/card"

const TICKET_DISPLAY_LIMIT = 3

function getStatusLabel(status: TicketList200TicketsItem["status"]): string {
  switch (status) {
    case "oc_in_progress":
    case "owner_in_progress":
    case "contractor_in_progress":
      return "進行中"
    case "completed":
      return "完了"
    default:
      return "不明"
  }
}

function getStatusVariant(status: TicketList200TicketsItem["status"]): "success" | "secondary" {
  return status === "completed" ? "secondary" : "success"
}

interface RelatedTicketsSectionContentProps {
  propertyId: number
}

export function RelatedTicketsSectionContent({ propertyId }: RelatedTicketsSectionContentProps) {
  const { data: ticketResponse } = ticketApi.useTicketListSuspense({
    propertyId,
    limit: TICKET_DISPLAY_LIMIT,
  })

  const tickets = ticketResponse?.tickets ?? []

  if (tickets.length === 0) {
    return (
      <div className="py-8 text-center text-sm text-slate-500">
        この物件に関連する案件はありません
      </div>
    )
  }

  return (
    <div className="space-y-4">
      {tickets.map((ticket) => (
        <div key={ticket.id} className="relative">
          <Link to={`/tickets/${ticket.id}`}>
            <DefaultCard
              title={ticket.title}
              text={ticket.content}
              subText={dateLib.formatDateTime(ticket.createdAt)}
              status={getStatusLabel(ticket.status)}
              statusVariant={getStatusVariant(ticket.status)}
              icon={<MessageCircle className="h-4 w-4 text-slate-400" />}
              className="cursor-pointer hover:shadow-md pr-10"
            />
            <ArrowRight
              className="absolute right-4 top-1/2 h-5 w-5 -translate-y-1/2 text-[#354267]"
              aria-hidden="true"
            />
          </Link>
        </div>
      ))}

      <div className="flex justify-end">
        <Link to={`/tickets?propertyId=${propertyId}`}>
          <Button variant="ghost" className="gap-2 font-bold">
            一覧を開く
            <ArrowRight className="h-4 w-4" />
          </Button>
        </Link>
      </div>
    </div>
  )
}
